import React from "react";
import { motion } from "framer-motion";

import { BsArrowDown as DownIcon } from "react-icons/bs";

const imageVariants = {
  hidden: {
    x: 250,
  },
  visible: {
    x: 0,
    transition: { duration: 1.5, type: "spring", stiffness: 50 },
  },
};

const contentVariants = {
  hidden: {
    x: -250,
  },
  visible: {
    x: 0,
    transition: { duration: 1, type: "spring", stiffness: 50 },
  },
};

const Hero = () => {
  return (
    <div className="relative min-h-screen justify-center items-center">
      <div className="flex items-center bg-slate-100/70 md:bg-transparent sm:justify-center max-w-6xl h-screen mx-auto ">
        <motion.div
          variants={contentVariants}
          initial="hidden"
          animate="visible"
          className="w-full p-4"
        >
          <h2 className="text-4xl font-semibold mb-2">Hello, I am</h2>

          <h2 className="md:text-8xl text-4xl my-10 font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#DD2476] via-[#FB680B] to-[#FF522C]">
            Jatin Soni
          </h2>

          <p className="font-semibold text-xl">
            I am a 20 years old
            <span className="text-yellow-500"> Web & App Developer</span> from
            Indore. I build unique, animated and amazing apps for the community.
          </p>

          <a
            href="#about"
            className="mt-10 md:h-24 flex justify-center w-14 h-14 items-center border-2 group border-slate-700 hover:bg-gray-200 transition-all duration-200 rounded-full p-3"
          >
            <DownIcon className="group-hover:translate-y-3 transition-all duration-200" />
          </a>
        </motion.div>

        <motion.div
          variants={imageVariants}
          initial="hidden"
          animate="visible"
          className="absolute top-0 left-0 pb-10 h-full w-full z-[-1] md:z-0 md:static md:h-auto aspect-square overflow-hidden"
        >
          <img
            className="h-full w-full overflow-hidden"
            src="./assets/images/Home.png"
            alt="hero"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
